<template>
  <div
    :id='id' class='c-modal modal' tabindex='0'
    style='z-index: 1003; display: none; opacity: 0; top: 4%; transform: scaleX(0.8) scaleY(0.8); width: 470px! important;'
  >
    <div class='type-voucher-container'>
      <div class='text-2xl-bold'>Tipo de comprobante</div>
      <div style='display: flex; flex-direction: column; gap: 16px;'>
        <div style='display: flex; gap: 12px; margin-left: -12px;'>
          <CustomRadioButton
            radioId='1'
            inputValue='1'
            v-model='typeVoucher'
            label='Boleta'
          />
          <CustomRadioButton
            radioId='6'
            inputValue='6'
            v-model='typeVoucher'
            label='Factura'
          />
        </div>

        <CustomCheckbox v-show="typeVoucher === '1'" checkboxId="is-ce" v-model="isCE" label="Tengo carnet de extranjería" />

        <InformativeMessage
          v-if="typeVoucher === '1' && documentNumber.length < 8 && !isCE"
          message='El nombre completo se completará automáticamente al ingresar 8 dígitos.'
        />
        <InformativeMessage
          v-if="typeVoucher === '6' && documentNumber.length < 11"
          message='La razon social se completará automáticamente al ingresar 11 dígitos.'
        />
        <InformativeMessage
          v-if="isCE && typeVoucher === '1'"
          message='En caso de carnet de extranjería, debes ingresar tus datos manualmente.'
        />

        <InputText
          :placeholder="typeVoucher === '1' ? isCE ? 'Ingresa tu número de CE' : 'Ingresa tu DNI' : 'Ingresa tu RUC'"
          v-model='documentNumber'
          :missingErrorMessage="typeVoucher === '1' ? isCE ? 'Ingresa tu CE' : 'Ingresa tu DNI' : 'Ingresa tu RUC'"
          :showEmptyInputError='tryToSubmit && !documentNumber'
        />
        <InputText
          :placeholder="typeVoucher === '1' ? 'Ingresa tu nombre completo' : 'Ingresa tu razón social'"
          v-model='displayName'
          missingErrorMessage='Ingresa tu nombre o razón social.'
          :showEmptyInputError='tryToSubmit && !displayName'
        />
        <InputText
          placeholder='Celular'
          v-model='phone'
          missingErrorMessage='Ingresa tu Celular.'
          :showEmptyInputError='tryToSubmit && !phone'
        />
        <InputText
          placeholder='Correo electrónico'
          v-model='email'
          missingErrorMessage='Ingresa tu Correo electrónico.'
          :showEmptyInputError='tryToSubmit && !email'
        />
      </div>
      <div class=''>
        <ButtonDefinitive
          label="Guardar"
          @click="sendVoucherData"
        />
        <ButtonDefinitive
          variant='tertiary'
          label="Cancelar"
          @click='handleCloseModal'
        />
      </div>
    </div>
  </div>
</template>

<script>
import ButtonDefinitive from '@/components/Button/ButtonDefinitive.vue'
import CustomRadioButton from '@/components/Form/CustomRadioButton.vue'
import InputText from '@/components/Form/InputText.vue'
import { getTaxpayerByDocument } from '../../services/taxpayer'
import InformativeMessage from "@/components/General/InformativeMessage.vue";
import CustomCheckbox from "../Form/CustomCheckbox.vue";

export default {
  name: "ModalTypeVoucher",
  components: {
    ButtonDefinitive,
    CustomRadioButton,
    InputText,
    InformativeMessage,
    CustomCheckbox,
  },
  props: {
    id: String,
  },
  data() {
    return {
      typeVoucher: "1", // 1: DNI, 6: RUC
      documentNumber: "",
      displayName: "",
      phone: "",
      email: "",
      isCE: false,
      tryToSubmit: false
    };
  },
  watch: {
    typeVoucher() {
      if (this.typeVoucher === '1') {
        this.documentNumber = this.user.dni || ''
        this.displayName = this.user.fullName || ''
      }
      if (this.typeVoucher === '6') {
        this.documentNumber = this.user.ruc || ''
        this.displayName = this.user.razonSocial || ''
      }
    },
    isCE() {
      if (this.isCE) {
        this.documentNumber = ''
        this.displayName = ''
      } else {
        this.documentNumber = this.user.dni || ''
        this.displayName = this.user.fullName || ''
      }
    },
    async documentNumber(newValue) {
      const isDni = this.typeVoucher === '1' && !this.isCE && newValue.length === 8;
      const isRuc = this.typeVoucher === '6' && newValue.length === 11;

      // CE is typed manually, so no lookup is made for it.
      if (!isDni && !isRuc) return;

      this.displayName = '';
      this.showLoading('Obteniendo datos...');

      try {
        const taxpayer = await getTaxpayerByDocument({
          type: parseInt(this.typeVoucher),
          docNumber: newValue
        });
        // A document without a match just leaves the field empty for the user to fill in.
        this.displayName = taxpayer?.razon_social || '';
      } finally {
        this.$swal.close();
      }
    }
  },
  computed: {
    user() {
      return this.$store.getters.USER;
    },
  },
  async mounted() {
    console.log(JSON.parse(JSON.stringify(this.user)))
    this.typeVoucher = this.user.ruc ? '6' : '1';
    this.documentNumber = this.user.ruc || this.user.dni;
    this.displayName = this.user.razonSocial || this.user.fullName;
    this.phone = this.user.celular;
    this.email = this.user.email;
  },
  methods: {
    getTaxpayerByDocument,
    validData() {
      if (!this.displayName) {
        this.showError('El nombre o razón social es obligatorio.')
        return false
      }
      if (!this.documentNumber) {
        this.showError('El número de documento es obligatorio.')
        return false
      }
      if (this.typeVoucher === '1' && !this.isCE && this.documentNumber.length !== 8) {
        this.showError('El DNI debe tener 8 caracteres.')
        return false
      }
      if (this.typeVoucher === '1' && !this.isCE && !/^[0-9]+$/.test(this.documentNumber)) {
        this.showError('El DNI debe contener solo dígitos numéricos.')
        return false
      }
      if (this.typeVoucher === '6' && !/^[0-9]+$/.test(this.documentNumber)) {
        this.showError('El RUC debe contener solo dígitos numéricos.')
        return false
      }
      // if (this.typeVoucher === '1' && this.isCE && (this.documentNumber.length < 9 || this.documentNumber.length > 12)) {
      //   this.showError('El número de carnet de extranjería debe tener entre 9 y 12 caracteres.')
      //   return false
      // }
      if (this.typeVoucher === '6' && this.documentNumber.length !== 11) {
        this.showError('El RUC debe tener 11 caracteres.')
        return false
      }
      if (!this.phone) {
        this.showError('El número de teléfono es obligatorio.')
        return false
      }
      if (this.phone.length !== 9) {
        this.showError('El número de teléfono debe tener 9 dígitos.')
        return false
      }
      if (!this.email) {
        this.showError('El correo electrónico es obligatorio.')
        return false
      }
      if (!this.validateEmail(this.email)) {
        this.showError('Por favor, ingrese un correo electrónico válido.')
        return false
      }
      return true
    },
    sendVoucherData() {
      if (this.validData()) {
        const voucherData = {
          typeVoucher: this.typeVoucher,
          isCE: this.isCE,
          documentNumber: this.documentNumber,
          displayName: this.displayName,
          phone: this.phone,
          email: this.email
        };
        this.$emit("getVoucherData", voucherData);
        this.closeModal(this.id);
      }
    },
    handleCloseModal() {
      this.closeModal(this.id);
    }
  },
};
</script>

<style lang='scss'>
.type-voucher-container {
  display: flex; flex-direction: column; gap: 32px;
  padding: 32px 20px;
}
</style>
